import {isEmpty} from 'lodash-es';

const contestantPage = {
    strict: true,
    namespaced: true,
    state: {
       /* actionUrls: null,*/
        activePage: null,
        registrationInfo: null,
        recentBlock: null,
        notificationData: null,
        customerInfo: null,
        countryOptions: [],
        phoneIndicatives: [],
        voteValidation: {
            canVote: false,
            alreadyVoted: false,
            phoneValidation: false,
            motive: null
        },
    },
    mutations: {
      /*  actionUrls(state, payload) {
            state.actionUrls = payload;
        },*/
        activePage(state, payload) {
            state.activePage = payload;
        },
        registrationInfo(state, payload) {
            state.registrationInfo = payload;
        },
        recentBlock(state, payload) {
            state.recentBlock = payload;
        },
        notificationData(state, payload) {
            state.notificationData = payload;
        },
        customerInfo(state, payload) {
            state.customerInfo = Object.assign({}, state.customerInfo, payload);
        },
        countryOptions(state, payload) {
            let parsedCountries = [];
            if(!isEmpty(payload)) {
                payload.forEach((element, index) => {
                    parsedCountries.push({
                        id: element.code,
                        text: element.name,
                        value: element.code,
                    });
                });
            }
            state.countryOptions = parsedCountries;
        },
        phoneIndicatives(state, payload) {
            state.phoneIndicatives = payload;
        },
        voteValidation(state, payload) {
            state.voteValidation = payload;
        },
    },
    actions: {
        setWsData(context, payload) {
            if(!isEmpty(payload)) {
                let wsData = payload.wsData;
                //console.log('participant module: ', payload);
                // data for root store & module
                /*context.commit('actionUrls', payload.actionUrls);*/
                context.commit('isLogged', payload.isLogged, { root: true });
                context.commit('kStrings', payload.kStrings, { root: true });
                context.commit('isDesktop', payload.isDesktop, { root: true });
                context.commit('urls', payload.baseUrls, { root: true });
                context.commit('activePage', wsData.activePage, { root: true });
                context.commit('pastimeInfo', wsData.pastimeInfo, { root: true });

                let enableRegistration = wsData.pastimeInfo?.detailedInfo?.enableRegistration ?? null;
                if(enableRegistration){
                    context.dispatch('setRegisterValidation', enableRegistration, { root: true });
                }

                context.commit('contestId', wsData.pastimeInfo.baseInfo.id, { root: true });
                context.commit('faqs', wsData.pastimeInfo.detailedInfo.faqsContent, { root: true });
                context.commit('rules', wsData.macwinContent.rulesContent, { root: true });
                context.commit('activePage', wsData.activePage);
                context.commit('customerRegistrationInfo', wsData.customerRegistrationInfo, { root: true });
                context.commit('registrationInfo', wsData.registrationInfo);

                context.dispatch('setVoteValidation', wsData.registrationInfo?.voteValidation ?? {});

                if(wsData.blocks){
                    if(!isEmpty(wsData.blocks.ranking)) {
                        context.commit('rankingBlock', wsData.blocks.ranking, { root: true });
                    }

                    if(!isEmpty(wsData.blocks.recent)) {
                        context.commit('recentBlock', wsData.blocks.recent, { root: true });
                    }

                    if(!isEmpty(wsData.blocks.ongoing)) {
                        context.commit('ongoingBlocks', wsData.blocks.ongoing, { root: true });
                    }
                }
               
                context.commit('customerInfo', payload.wsData.customerInfo);
                context.commit('countryOptions', payload.wsData.pastimeInfo.countries);
                context.commit('phoneIndicatives', payload.wsData.pastimeInfo.phoneIndicatives);
            }
        },
        setActivePage(context, payload) {
            context.commit('activePage', payload);
        },
        setRegistrationInfo(context, payload) {
            context.commit('registrationInfo', payload);
        },
        setRecentBlock(context, payload) {
            context.commit('recentBlock', payload);
        },
        loadNotification(context, payload) {
            context.commit('notificationData', payload);
            setTimeout(() => { 
                context.commit('notificationData', null);
            }, typeof payload.duration !== 'undefined' ? payload.duration : 4000);
        },
        setCustomerInfo(context, payload) {
            context.commit('customerInfo', payload);
        },
        setCountryOptions(context, payload) {
            context.commit('countryOptions', payload);
        }, 
        setPhoneIndicatives(context, payload) {
            context.commit('phoneIndicatives', payload);
        },
        setVoteValidation(context, payload) {
            let data = {
                canVote: payload?.canVote ?? false,
                alreadyVoted: payload?.alreadyVoted ?? false,
                phoneValidation: payload?.phoneValidation ?? false,
                motive: payload?.motive ?? null,
            };
            context.commit('voteValidation', data);
        },
    },
    getters: {
      /*  actionUrls: state => state.actionUrls,*/
        activePage: state => state.activePage,
        registrationInfo: state => state.registrationInfo,
        recentBlock: state => state.recentBlock,
        notificationData: state => state.notificationData,
        customerInfo: state => state.customerInfo,
        countryOptions: state => state.countryOptions,
        phoneIndicatives: state => state.phoneIndicatives,
        voteValidation: state => state.voteValidation,
    },
};

export default contestantPage;